var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 828.6 600",
    viewBox: "0 0 828.6 600",
    id: "NftGame",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 295.723,
    x2: 364.42,
    y1: 415.266,
    y2: 477.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 370.4,
    x2: 289.8,
    y1: 469.5,
    y2: 422.9,
    fill: "none",
    stroke: "url(#a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 525.783,
    x2: 591.501,
    y1: 396.583,
    y2: 455.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#b)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: " M513.3,411.5l36.9,21.6c2.1,1.2,4.7,1.2,6.8,0l13.4-7.7c2.1-1.2,4.6-1.2,6.7,0l26.9,15.5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 543.516,
    x2: 573.769,
    y1: 384.909,
    y2: 412.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: " M525.1,406.4l16.6,9.6c2.1,1.2,4.6,1.2,6.7,0l43.7-25.2",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 510.224,
    x2: 556.668,
    y1: 313.007,
    y2: 354.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#d)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: " M513.3,310.7l26.1,15.1c1.9,1.1,1.9,3.7,0,4.8l-11.8,6.8c-1.9,1.1-1.9,3.7,0,4.8l26.1,15.1",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 507.45,
    x2: 552.547,
    y1: 329.32,
    y2: 369.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#e)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: " M580.4,338l-25.5,14.7c-3,1.7-6.6,1.7-9.5,0l-22.1-12.8c-2.1-1.2-4.6-1.2-6.7,0l-37,21.3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 212.312,
    x2: 253.834,
    y1: 298.65,
    y2: 336.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#f)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: " M276.7,309.6l-13.1,7.5c-2.3,1.3-5.1,1.3-7.3,0l-23.2-13.4c-2.1-1.2-4.6-1.2-6.7,0l-37,21.3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 354.58,
    x2: 370.533,
    y1: 476.819,
    y2: 491.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#g)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: " M389.1,459l-36.1,20.9c-1.9,1.1-1.9,3.7,0,4.8l11.8,6.8c1.9,1.1,1.9,3.7,0,4.8l-26.1,15.1",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -1638.781,
    x2: -1622.827,
    y1: 441.827,
    y2: 456.199,
    gradientTransform: "matrix(-1 0 0 1 -1327.063 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#h)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    d: " M277.2,424l36.1,20.9c1.9,1.1,1.9,3.7,0,4.8l-11.8,6.8c-1.9,1.1-1.9,3.7,0,4.8l26.1,15.1",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 514.698,
    x2: 523.746,
    y1: 292.016,
    y2: 300.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 534.3,
    x2: 504.1,
    y1: 287.4,
    y2: 304.8,
    fill: "none",
    stroke: "url(#i)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 606.357,
    x2: 614.071,
    y1: 333.486,
    y2: 308.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#d6f4f6",
    stopOpacity: 0.219,
    className: "stopColord6e6f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#j)",
    points: "613.1 337.8 639.7 322.3 601.9 310.2 579.9 322.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 590.762,
    x2: 588.577,
    y1: 299.015,
    y2: 341.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M589.9,307.6c-1.1-0.2-2.3,0-3.1,0.5 l-9.7,5.6l-0.7-0.1v26.2c0.1,0.1,0.2,0.1,0.2,0.2c0.4,0.2,0.9,0.4,1.4,0.5l22.2,3.4c0.6,0.1,1.2,0.1,1.8,0v-34.3L589.9,307.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 571.173,
    x2: 585.852,
    y1: 331.181,
    y2: 292.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M569.7,312.7v13.1c0,0,0,0.1,0,0.1v0 c0,0,0,0,0,0c0,0.1,0,0.3,0.1,0.4l6,12.9c0.1,0.2,0.3,0.4,0.6,0.6v-26.2L569.7,312.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 602.902,
    x2: 614.794,
    y1: 314.302,
    y2: 339.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M620.5,319.6l-2.9-0.4l-3.2-6.9 c-0.1-0.3-0.4-0.6-0.8-0.8c-0.4-0.2-0.9-0.4-1.4-0.5l-10-1.5v34.3c0.5-0.1,0.9-0.2,1.2-0.4l16.2-9.4c0.6-0.4,0.9-0.8,0.9-1.3 c0,0,0,0,0,0L620.5,319.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 700.247,
    x2: 574.431,
    y1: 408.19,
    y2: 297.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#90e0e6",
    className: "stopColor90ade6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M613.5,305.4c-0.4-0.2-0.9-0.4-1.4-0.5 l-22.2-3.4c-1.1-0.2-2.3,0-3.1,0.5l-16.2,9.4c-0.8,0.5-1.1,1.1-0.8,1.8l6,12.9c0.1,0.3,0.4,0.6,0.8,0.8s0.9,0.4,1.4,0.5 l22.2,3.4c1.1,0.2,2.3,0,3.1-0.5l16.2-9.4c0.8-0.5,1.1-1.1,0.8-1.8l-6-12.9C614.2,305.9,613.9,305.6,613.5,305.4"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 580.833,
    x2: 589.833,
    y1: 279.401,
    y2: 260.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#d6f4f6",
    stopOpacity: 0.219,
    className: "stopColord6e6f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#o)",
    points: "525.8 270.7 574 289.2 659.5 239.5 611.3 221"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 550.951,
    x2: 548.704,
    y1: 247.225,
    y2: 291.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M550.6,256.1c-1.4-0.2-2.9,0-3.9,0.6 l-12.4,7.2l-1.4-0.2v24.1c0.2,0.2,0.5,0.5,0.8,0.7c0.5,0.3,1.1,0.5,1.8,0.6l28.4,4.4c0.7,0.1,1.3,0.1,2,0v-35.1L550.6,256.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 525.657,
    x2: 540.014,
    y1: 284.652,
    y2: 241.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M524.8,262.6v7.7c0,0,0,0.1,0,0.1v0.1 c0,0,0,0,0,0c0,0.2,0,0.3,0.1,0.5l7.7,16.4c0.1,0.1,0.2,0.3,0.3,0.4v-24.1L524.8,262.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 589.896,
    x2: 569.11,
    y1: 288.591,
    y2: 274.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M589.7,271.5L586,271l-4.1-8.8 c-0.2-0.4-0.6-0.8-1.1-1c-0.5-0.3-1.1-0.5-1.8-0.6l-13.1-2v35.1c0.7-0.1,1.4-0.3,2-0.6l20.7-12c0.8-0.5,1.2-1.1,1.2-1.7 c0,0,0,0,0,0L589.7,271.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 588.077,
    x2: 539.541,
    y1: 301.851,
    y2: 246.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#04b9c7",
    className: "stopColor0446c7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#0fbbc9",
    className: "stopColor0f4ec9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#22c1ce",
    className: "stopColor225cce svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#3dc9d4",
    className: "stopColor3d70d4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#60d2db",
    className: "stopColor608adb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#8adee5",
    className: "stopColor8aa9e5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bdecf0",
    className: "stopColorbdcef0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#f6fcfd",
    className: "stopColorf6f8fd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M580.8,253.2c-0.5-0.3-1.1-0.5-1.8-0.6 l-28.4-4.4c-1.4-0.2-2.9,0-3.9,0.6l-20.7,12c-1,0.6-1.4,1.5-1,2.3l7.7,16.4c0.2,0.4,0.6,0.8,1.1,1.1c0.5,0.3,1.1,0.5,1.8,0.6 l28.4,4.4c1.4,0.2,2.9,0,3.9-0.6l20.7-12c1-0.6,1.4-1.5,1-2.3l-7.7-16.5C581.7,253.9,581.3,253.5,580.8,253.2"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 550.951,
    x2: 548.704,
    y1: 236.787,
    y2: 280.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M550.6,245.7c-1.4-0.2-2.9,0-3.9,0.6 l-12.4,7.2l-1.4-0.2v24.1c0.2,0.2,0.5,0.5,0.8,0.7c0.5,0.3,1.1,0.5,1.8,0.6l28.4,4.4c0.7,0.1,1.3,0.1,2,0V248L550.6,245.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 525.657,
    x2: 540.014,
    y1: 274.215,
    y2: 231.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M524.8,252.2v7.7c0,0,0,0.1,0,0.1v0.1 c0,0,0,0,0,0c0,0.2,0,0.3,0.1,0.5l7.7,16.4c0.1,0.1,0.2,0.3,0.3,0.4v-24.1L524.8,252.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 589.896,
    x2: 569.11,
    y1: 278.154,
    y2: 264.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M589.7,261.1l-3.7-0.5l-4.1-8.8 c-0.2-0.4-0.6-0.8-1.1-1c-0.5-0.3-1.1-0.5-1.8-0.6l-13.1-2v35.1c0.7-0.1,1.4-0.3,2-0.6l20.7-12c0.8-0.5,1.2-1.1,1.2-1.7 c0,0,0,0,0,0L589.7,261.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 691.745,
    x2: 530.826,
    y1: 374.304,
    y2: 233.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#90e0e6",
    className: "stopColor90ade6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M580.8,242.8c-0.5-0.3-1.1-0.5-1.8-0.6 l-28.4-4.4c-1.4-0.2-2.9,0-3.9,0.6l-20.7,12c-1,0.6-1.4,1.5-1,2.3l7.7,16.4c0.2,0.4,0.6,0.8,1.1,1.1c0.5,0.3,1.1,0.5,1.8,0.6 l28.4,4.4c1.4,0.2,2.9,0,3.9-0.6l20.7-12c1-0.6,1.4-1.5,1-2.3l-7.7-16.5C581.7,243.4,581.3,243.1,580.8,242.8"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 279.943,
    x2: 288.943,
    y1: 269.798,
    y2: 251.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#d6f4f6",
    stopOpacity: 0.219,
    className: "stopColord6e6f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#x)",
    points: "224.9 261.1 273.1 279.6 358.6 229.9 310.4 211.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 250.06,
    x2: 247.813,
    y1: 237.622,
    y2: 281.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M249.7,246.5c-1.4-0.2-2.9,0-3.9,0.6 l-12.4,7.2l-1.4-0.2v24.1c0.2,0.2,0.5,0.5,0.8,0.7c0.5,0.3,1.1,0.5,1.8,0.6l28.4,4.4c0.7,0.1,1.3,0.1,2,0v-35.1L249.7,246.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 224.766,
    x2: 239.123,
    y1: 275.049,
    y2: 232.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M223.9,253v7.7c0,0,0,0.1,0,0.1v0.1 c0,0,0,0,0,0c0,0.2,0,0.3,0.1,0.5l7.7,16.4c0.1,0.1,0.2,0.3,0.3,0.4v-24.1L223.9,253z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 289.006,
    x2: 268.22,
    y1: 278.988,
    y2: 264.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M288.8,261.9l-3.7-0.5l-4.1-8.8 c-0.2-0.4-0.6-0.8-1.1-1c-0.5-0.3-1.1-0.5-1.8-0.6l-13.1-2v35.1c0.7-0.1,1.4-0.3,2-0.6l20.7-12c0.8-0.5,1.2-1.1,1.2-1.7 c0,0,0,0,0,0L288.8,261.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 287.187,
    x2: 238.651,
    y1: 292.248,
    y2: 237.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#04b9c7",
    className: "stopColor0446c7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279,
    stopColor: "#0fbbc9",
    className: "stopColor0f4ec9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#22c1ce",
    className: "stopColor225cce svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#3dc9d4",
    className: "stopColor3d70d4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.637,
    stopColor: "#60d2db",
    className: "stopColor608adb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#8adee5",
    className: "stopColor8aa9e5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bdecf0",
    className: "stopColorbdcef0 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#f6fcfd",
    className: "stopColorf6f8fd svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M279.9,243.6c-0.5-0.3-1.1-0.5-1.8-0.6 l-28.4-4.4c-1.4-0.2-2.9,0-3.9,0.6l-20.7,12c-1,0.6-1.4,1.5-1,2.3l7.7,16.5c0.2,0.4,0.6,0.8,1.1,1.1c0.5,0.3,1.1,0.5,1.8,0.6 L263,276c1.4,0.2,2.9,0,3.9-0.6l20.7-12c1-0.6,1.4-1.5,1-2.3l-7.7-16.5C280.8,244.3,280.4,243.9,279.9,243.6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 250.06,
    x2: 247.813,
    y1: 227.185,
    y2: 271.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M249.7,236.1c-1.4-0.2-2.9,0-3.9,0.6 l-12.4,7.2l-1.4-0.2v24.1c0.2,0.2,0.5,0.5,0.8,0.7c0.5,0.3,1.1,0.5,1.8,0.6l28.4,4.4c0.7,0.1,1.3,0.1,2,0v-35.1L249.7,236.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 224.766,
    x2: 239.123,
    y1: 264.612,
    y2: 221.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#dceaeb",
    className: "stopColordce4eb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#4ce0ec",
    className: "stopColor4c95ec svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dced",
    className: "stopColor006ced svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M223.9,242.6v7.7c0,0,0,0.1,0,0.1v0.1 c0,0,0,0,0,0c0,0.2,0,0.3,0.1,0.5l7.7,16.4c0.1,0.1,0.2,0.3,0.3,0.4v-24.1L223.9,242.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 289.006,
    x2: 268.22,
    y1: 268.551,
    y2: 254.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M288.8,251.4l-3.7-0.5l-4.1-8.8 c-0.2-0.4-0.6-0.8-1.1-1c-0.5-0.3-1.1-0.5-1.8-0.6l-13.1-2v35.1c0.7-0.1,1.4-0.3,2-0.6l20.7-12c0.8-0.5,1.2-1.1,1.2-1.7 c0,0,0,0,0,0L288.8,251.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 390.855,
    x2: 229.935,
    y1: 364.701,
    y2: 223.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "#90e0e6",
    className: "stopColor90ade6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M279.9,233.2c-0.5-0.3-1.1-0.5-1.8-0.6 l-28.4-4.4c-1.4-0.2-2.9,0-3.9,0.6l-20.7,12c-1,0.6-1.4,1.5-1,2.3l7.7,16.5c0.2,0.4,0.6,0.8,1.1,1.1c0.5,0.3,1.1,0.5,1.8,0.6 l28.4,4.4c1.4,0.2,2.9,0,3.9-0.6l20.7-12c1-0.6,1.4-1.5,1-2.3l-7.7-16.5C280.8,233.8,280.4,233.5,279.9,233.2"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 388.492,
    x2: 451.65,
    y1: 438.172,
    y2: 235.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#d6f4f6",
    stopOpacity: 0.219,
    className: "stopColord6e6f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M422,272c-42.6-24.3-96.1-18-131.7,15.8 c-19.8,18.8-34.2,37.3-34,47.1c0,0.7,0.1,1.4,0.2,2.1c-0.1,0.7-0.2,1.3-0.2,2c0.1,7.6,4.6,13.3,11.4,17.2 c12.6,7.3,32.9,8.6,47.4,5.8c22.3-4.4,61.4-19.7,95.1-0.2c7.4,4.3,12,8.8,14.4,13.2c-3.8,16.6-11,31.8-14.5,37.7 c-1.9,3.2-2.7,7-2.2,10.8c-0.9,7.2,2.8,15.3,12.4,20.8c6.8,3.9-5.6,23.6,7.5,23.6c37.5,0.1,111.1-58.6,136.8-83.7 c8.5-8.3,11.7-15.6,11.8-22l0,0c0,0,0,0,0-0.1c0-0.2,0-0.4,0-0.6l0,0c0-0.9-0.5-1.8-1.3-2.3L422,272z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 545.213,
    x2: 528.239,
    y1: 348.534,
    y2: 319.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.091,
    stopColor: "#85d0d6",
    className: "stopColora285d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#71cdd4",
    className: "stopColor717cd4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#48c9d3",
    className: "stopColor4875d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#21929b",
    className: "stopColor296fd2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#12c4d2",
    className: "stopColor126bd2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#05c2d1",
    className: "stopColor0569d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#02c2d1",
    className: "stopColor0268d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#09c2d1",
    className: "stopColor0969d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#14c4d2",
    className: "stopColor146ad2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#25c6d3",
    className: "stopColor256bd3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#3bc9d4",
    className: "stopColor3b6cd4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#56ccd5",
    className: "stopColor566ed5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#5eccd5",
    className: "stopColor5e6fd5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#74ced5",
    className: "stopColor7475d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7dcfd6",
    className: "stopColor917dd6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#83d0d6",
    className: "stopColora983d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#88d1d7",
    className: "stopColorbc88d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#8bd1d7",
    className: "stopColorc98bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#8dd2d7",
    className: "stopColord18dd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M543.7,335.3v-13.6l0,0 c0.1-1-0.5-1.9-1.7-2.7l-16.5-9.5c-2.4-1.4-6.2-1.4-8.5,0l-0.6,0.3c3.6,2.1,6.8,3.9,9.3,5.4c2.8,1.6,6.1,3.7,9.1,6.1l-1.1-0.1v7 l-8.2-4.7c-2.4-1.4-6.2-1.4-8.5,0l-0.6,0.3c3.6,2.1,6.8,3.9,9.3,5.4c4.3,2.5,9.6,5.9,13.8,10.2l2.5-1.5 C543.2,337.2,543.8,336.2,543.7,335.3L543.7,335.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 438.751,
    x2: 421.777,
    y1: 287.85,
    y2: 258.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.091,
    stopColor: "#85d0d6",
    className: "stopColora285d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.194,
    stopColor: "#71cdd4",
    className: "stopColor717cd4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#48c9d3",
    className: "stopColor4875d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#21929b",
    className: "stopColor296fd2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493,
    stopColor: "#12c4d2",
    className: "stopColor126bd2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#05c2d1",
    className: "stopColor0569d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#02c2d1",
    className: "stopColor0268d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712,
    stopColor: "#09c2d1",
    className: "stopColor0969d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#14c4d2",
    className: "stopColor146ad2 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#25c6d3",
    className: "stopColor256bd3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#3bc9d4",
    className: "stopColor3b6cd4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#56ccd5",
    className: "stopColor566ed5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#5eccd5",
    className: "stopColor5e6fd5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#74ced5",
    className: "stopColor7475d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#7dcfd6",
    className: "stopColor917dd6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    stopColor: "#83d0d6",
    className: "stopColora983d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "#88d1d7",
    className: "stopColorbc88d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#8bd1d7",
    className: "stopColorc98bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#8dd2d7",
    className: "stopColord18dd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M438.5,274.7v-13.9l0,0 c0-0.9-0.6-1.8-1.8-2.5l-16.5-9.5c-2.3-1.4-6.2-1.4-8.5,0l-2.5,1.5c7.5,2.4,13.4,5.5,17.7,8c2.1,1.2,4.7,2.7,7.6,4.4l-2.3,6.4 l0.4,0.9l-12.4-7.1c-2.3-1.4-6.2-1.4-8.5,0l-2.5,1.5c7.5,2.4,13.4,5.5,17.7,8c2.5,1.4,5.7,3.3,9.3,5.4l0.6-0.3 c1.1-0.7,1.7-1.5,1.7-2.4l0,0V274.7C438.5,274.8,438.5,274.7,438.5,274.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 444.596,
    x2: 475.453,
    y1: 428.41,
    y2: 468.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M547.3,381.9c0-0.2,0-0.4,0-0.6 c0-4.9,0-36.7,0-39.5c0,0-15.3,6-18.3,10.6c-0.5,0.7-0.8,2.1-0.9,3.8c-0.8-0.5-1.7-1-2.4-1.5c-2.5-1.4-5.7-3.3-9.3-5.4 c-1.2-0.7-2.5-1.4-3.7-2.2l-72.6-41.9c-1.3-0.7-2.5-1.5-3.8-2.2c-3.6-2.1-6.8-3.9-9.3-5.4c-4.3-2.5-10.2-5.5-17.7-8 c-15.6-5.1-38.2-7.7-67.4,2.4c-43.2,15-115,44.9-114.6,66.6c0.1,7.6,4.6,13.3,11.4,17.2c12.6,7.3,32.9,8.6,47.4,5.8 c22.3-4.4,61.4-19.7,95.1-0.2c33.7,19.4,7.5,42.1-0.1,55.1c-4.9,8.4-2.5,20.2,10.1,27.4c6.8,3.9,16.6,6.5,29.7,6.6 c37.5,0.1,88.9-41.5,114.6-66.6C544,395.7,547.2,388.3,547.3,381.9L547.3,381.9C547.3,381.9,547.3,381.9,547.3,381.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "K",
    cx: 315.357,
    cy: 381.071,
    r: 59.848,
    gradientTransform: "matrix(.08938 .996 -3.7024 .3323 1698.043 -59.64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#82cfd5",
    stopOpacity: 0.689,
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00c2d1",
    stopOpacity: 0,
    className: "stopColor0068d1 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    d: "M547.3,381.9c0-0.2,0-0.4,0-0.6 c0-4.9,0-36.7,0-39.5c0,0-15.3,6-18.3,10.6c-0.5,0.7-0.8,2.1-0.9,3.8c-0.8-0.5-1.7-1-2.4-1.5c-2.5-1.4-5.7-3.3-9.3-5.4 c-1.2-0.7-2.5-1.4-3.7-2.2l-72.6-41.9c-1.3-0.7-2.5-1.5-3.8-2.2c-3.6-2.1-6.8-3.9-9.3-5.4c-4.3-2.5-10.2-5.5-17.7-8 c-15.6-5.1-38.2-7.7-67.4,2.4c-43.2,15-115,44.9-114.6,66.6c0.1,7.6,4.6,13.3,11.4,17.2c12.6,7.3,32.9,8.6,47.4,5.8 c22.3-4.4,61.4-19.7,95.1-0.2c33.7,19.4,7.5,42.1-0.1,55.1c-4.9,8.4-2.5,20.2,10.1,27.4c6.8,3.9,16.6,6.5,29.7,6.6 c37.5,0.1,88.9-41.5,114.6-66.6C544,395.7,547.2,388.3,547.3,381.9L547.3,381.9C547.3,381.9,547.3,381.9,547.3,381.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "L",
    x1: 449.644,
    x2: 351.534,
    y1: 527.927,
    y2: 245.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#11c3d1",
    className: "stopColor116bd1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#55cad3",
    className: "stopColor5577d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#81cfd5",
    className: "stopColor8b81d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#88d0d6",
    className: "stopColorb288d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#8cd1d7",
    className: "stopColorca8cd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    d: "M439.9,265.7c-1.3-0.7-2.5-1.5-3.8-2.2 c-3.6-2.1-6.8-3.9-9.3-5.4c-4.3-2.5-10.2-5.5-17.7-8c-15.6-5.1-38.2-7.7-67.4,2.4c-43.2,15-115,80.3-114.6,102 c0.1,7.6,4.6,13.3,11.4,17.2c12.6,7.3,32.9,8.6,47.4,5.8c22.3-4.4,61.4-55,95.1-35.6c33.7,19.4,7.5,77.5-0.1,90.4 c-4.9,8.4-2.5,20.2,10.1,27.4c6.8,3.9,16.6,6.5,29.7,6.6c37.5,0.1,88.9-76.9,114.6-102c17.4-17,12.8-30,3.9-39 c-4.3-4.3-9.5-7.7-13.8-10.2c-2.5-1.4-5.7-3.3-9.3-5.4c-1.2-0.7-2.5-1.4-3.7-2.2L439.9,265.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 499.73,
    x2: 414.23,
    y1: 256.467,
    y2: 355.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#11c3d1",
    className: "stopColor116bd1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#55cad3",
    className: "stopColor5577d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#81cfd5",
    className: "stopColor8b81d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#88d0d6",
    className: "stopColorb288d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#8cd1d7",
    className: "stopColorca8cd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    d: "M431.8,270.4c-3.7,2.1-5.8,5-5.9,8.1 c-0.2,9.2,0.1,29,7.3,33.2c7.2,4.2,41.3,4.3,57.3,4.1c5.3-0.1,10.3-1.3,13.9-3.4l8.1-4.7l-72.6-41.9L431.8,270.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "N",
    x1: 481.229,
    x2: 469.337,
    y1: 272.771,
    y2: 292.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    stopOpacity: 0,
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    d: "M485,311.1c-38.1,0-46-2.9-47.6-3.8 c-4-2.3-6.3-14.3-5.8-30.5c0.1-1.9,1.7-4,4.4-5.6l6.6-3.9l66.7,38.5l-3.7,2.1c-3.2,1.9-7.8,3-12.5,3 C490.8,311,488,311.1,485,311.1C485,311.1,485,311.1,485,311.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 384.261,
    x2: 406.723,
    y1: 282.605,
    y2: 257.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#49cdd8",
    stopOpacity: 0.861,
    className: "stopColor4994d8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#56d1db",
    stopOpacity: 0.714,
    className: "stopColor569bdb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#6bd6df",
    stopOpacity: 0.563,
    className: "stopColor6ba7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#89dfe6",
    stopOpacity: 0.41,
    className: "stopColor89b9e6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#afe9ee",
    stopOpacity: 0.256,
    className: "stopColorafd0ee svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#ddf6f8",
    stopOpacity: 0.101,
    className: "stopColorddebf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    d: "M408.7,265.3l-6.3-3.6 c-2.2-1.2-5.6-1.2-7.8,0l-10.1,5.8c-1.2,0.7-1.7,1.6-1.6,2.6l0.6,3.3c0.1,0.7,0.7,1.4,1.6,1.9c0.9,0.5,2,0.8,3.3,0.9l5.7,0.4 c1.7,0.1,3.3-0.2,4.5-0.9l10.1-5.8C410.9,268.6,410.9,266.5,408.7,265.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    x1: 352.827,
    x2: 375.286,
    y1: 300.138,
    y2: 274.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#49cdd8",
    stopOpacity: 0.861,
    className: "stopColor4994d8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#56d1db",
    stopOpacity: 0.714,
    className: "stopColor569bdb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#6bd6df",
    stopOpacity: 0.563,
    className: "stopColor6ba7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#89dfe6",
    stopOpacity: 0.41,
    className: "stopColor89b9e6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#afe9ee",
    stopOpacity: 0.256,
    className: "stopColorafd0ee svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#ddf6f8",
    stopOpacity: 0.101,
    className: "stopColorddebf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    d: "M376.9,283c-0.1-0.7-0.7-1.4-1.6-1.9 c-0.9-0.5-2-0.8-3.3-0.9l-5.7-0.4c-1.7-0.1-3.3,0.2-4.5,0.9l-10.1,5.8c-2.1,1.2-2.1,3.3,0,4.5l6.3,3.6c2.2,1.2,5.6,1.2,7.8,0 l10.1-5.8c1.2-0.7,1.7-1.6,1.6-2.6L376.9,283z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 355.371,
    x2: 372.708,
    y1: 279.418,
    y2: 259.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#49cdd8",
    stopOpacity: 0.861,
    className: "stopColor4994d8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#56d1db",
    stopOpacity: 0.714,
    className: "stopColor569bdb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#6bd6df",
    stopOpacity: 0.563,
    className: "stopColor6ba7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#89dfe6",
    stopOpacity: 0.41,
    className: "stopColor89b9e6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#afe9ee",
    stopOpacity: 0.256,
    className: "stopColorafd0ee svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#ddf6f8",
    stopOpacity: 0.101,
    className: "stopColorddebf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    d: "M375.9,267.5l-10.1-5.8 c-2.2-1.2-5.6-1.2-7.8,0l-6.3,3.6c-2.1,1.2-2.1,3.3,0,4.5l10.1,5.8c1.2,0.7,2.8,1,4.5,0.9l5.7-0.4c2.6-0.2,4.6-1.3,4.9-2.8 l0.6-3.3C377.6,269.1,377,268.2,375.9,267.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "R",
    x1: 387.071,
    x2: 404.408,
    y1: 297.313,
    y2: 277.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#49cdd8",
    stopOpacity: 0.861,
    className: "stopColor4994d8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#56d1db",
    stopOpacity: 0.714,
    className: "stopColor569bdb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "#6bd6df",
    stopOpacity: 0.563,
    className: "stopColor6ba7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#89dfe6",
    stopOpacity: 0.41,
    className: "stopColor89b9e6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#afe9ee",
    stopOpacity: 0.256,
    className: "stopColorafd0ee svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#ddf6f8",
    stopOpacity: 0.101,
    className: "stopColorddebf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    d: "M408.9,286.6l-10.1-5.8 c-1.2-0.7-2.8-1-4.5-0.9l-5.7,0.4c-2.6,0.2-4.6,1.3-4.9,2.8l-0.6,3.3c-0.2,1,0.4,1.9,1.6,2.6l10.1,5.8c2.2,1.2,5.6,1.2,7.8,0 l6.3-3.6C411,289.8,411,287.8,408.9,286.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 391.037,
    x2: 393.975,
    y1: 261.833,
    y2: 295.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    d: "M380.3,278.3c0.9,0.5,2,0.8,3.3,0.9 l5.7,0.4c1.7,0.1,3.3-0.2,4.5-0.9l10.1-5.8c1.1-0.6,1.6-1.4,1.6-2.2l0,0v0c0,0,0,0,0,0V266l-2.6,0.8l-0.4,0.7l-5-2.9 c-2.2-1.2-5.6-1.2-7.8,0l-7.6,4.4l0.2-0.4L378,268v4.6l0,0c0,0.2,0,0.3,0,0.5l0.6,3.3C378.8,277.1,379.4,277.8,380.3,278.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 358.24,
    x2: 361.178,
    y1: 280.889,
    y2: 314.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    d: "M372.6,289.5v-4.3l-0.8,0.3 c-0.3-0.5-0.8-1-1.4-1.4c-0.9-0.5-2-0.8-3.3-0.9l-5.7-0.4c-1.7-0.1-3.3,0.2-4.5,0.9l-8.6,5l-0.3-1.1l-2.8-0.4v4.6c0,0,0,0,0,0v0 c0,0,0,0,0,0c0,0.8,0.6,1.6,1.6,2.2l6.3,3.6c2.2,1.2,5.6,1.2,7.8,0l10.1-5.8c1-0.6,1.5-1.3,1.6-2.1l0,0v-0.1 C372.6,289.6,372.6,289.6,372.6,289.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "U",
    x1: 391.079,
    x2: 394.168,
    y1: 280.316,
    y2: 315.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    d: "M405.5,291.6L405.5,291.6l0-4.3 l-5.1,0.1l0,0l-6.7-3.8c-1.2-0.7-2.8-1-4.5-0.9l-5.7,0.4c-2.2,0.1-3.9,1-4.6,2.1l-0.9-0.2v4.5c0,0,0,0.1,0,0.1v0.1l0,0 c0.1,0.8,0.6,1.6,1.6,2.2l10.1,5.8c2.2,1.2,5.6,1.2,7.8,0l6.3-3.6C405,293.4,405.5,292.5,405.5,291.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "V",
    x1: 358.101,
    x2: 361.19,
    y1: 261.4,
    y2: 296.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    d: "M345.1,270.6c0,0.8,0.6,1.6,1.6,2.2 l10.1,5.8c1.2,0.7,2.8,1,4.5,0.9l5.7-0.4c2.6-0.2,4.6-1.3,4.9-2.8l0.6-3.3c0-0.2,0-0.3,0-0.5l0,0v-4.4l-1,2.4c0,0,0,0.1-0.1,0.3 c-0.2-0.1-0.3-0.3-0.6-0.4l-10.1-5.8c-2.2-1.2-5.6-1.2-7.8,0l-4.6,2.6l-0.8-1.2l-2.5-0.2v4.6 C345.1,270.5,345.1,270.5,345.1,270.6L345.1,270.6C345.1,270.6,345.1,270.6,345.1,270.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "W",
    x1: 390.334,
    x2: 395.603,
    y1: 262.418,
    y2: 282.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    d: "M403.8,263.7l-6.3-3.6 c-2.2-1.2-5.6-1.2-7.8,0l-10.1,5.8c-1.2,0.7-1.7,1.6-1.6,2.6l0.6,3.3c0.1,0.7,0.7,1.4,1.6,1.9c0.9,0.5,2,0.8,3.3,0.9l5.7,0.4 c1.7,0.1,3.3-0.2,4.5-0.9l10.1-5.8C405.9,267,405.9,264.9,403.8,263.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "X",
    x1: 357.776,
    x2: 363.045,
    y1: 281.41,
    y2: 301.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    d: "M371.9,281.4c-0.1-0.7-0.7-1.4-1.6-1.9 c-0.9-0.5-2-0.8-3.3-0.9l-5.7-0.4c-1.7-0.1-3.3,0.2-4.5,0.9l-10.1,5.8c-2.1,1.2-2.1,3.3,0,4.5l6.3,3.6c2.2,1.2,5.6,1.2,7.8,0 l10.1-5.8c1.2-0.7,1.7-1.6,1.6-2.6L371.9,281.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Y",
    x1: 357.442,
    x2: 363.795,
    y1: 261.968,
    y2: 285.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    d: "M370.9,265.9l-10.1-5.8 c-2.2-1.2-5.6-1.2-7.8,0l-6.3,3.6c-2.1,1.2-2.1,3.3,0,4.5l10.1,5.8c1.2,0.7,2.8,1,4.5,0.9l5.7-0.4c2.6-0.2,4.6-1.3,4.9-2.8 l0.6-3.3C372.6,267.5,372.1,266.6,370.9,265.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 390.152,
    x2: 396.504,
    y1: 279.94,
    y2: 303.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    d: "M403.9,285l-10.1-5.8 c-1.2-0.7-2.8-1-4.5-0.9l-5.7,0.4c-2.6,0.2-4.6,1.3-4.9,2.8l-0.6,3.3c-0.2,1,0.4,1.9,1.6,2.6l10.1,5.8c2.2,1.2,5.6,1.2,7.8,0 l6.3-3.6C406,288.2,406,286.2,403.9,285z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 458.542,
    x2: 515.192,
    y1: 377.25,
    y2: 313.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#47ccd7",
    stopOpacity: 0.603,
    className: "stopColor4792d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#4ecfd9",
    stopOpacity: 0.46,
    className: "stopColor4e96d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#59d1db",
    stopOpacity: 0.358,
    className: "stopColor599ddb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6ad6df",
    stopOpacity: 0.276,
    className: "stopColor6aa7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#80dde4",
    stopOpacity: 0.205,
    className: "stopColor80b4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#9ce4ea",
    stopOpacity: 0.142,
    className: "stopColor9cc4ea svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#bcedf1",
    stopOpacity: 0.086,
    className: "stopColorbcd7f1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#e0f6f8",
    stopOpacity: 0.036,
    className: "stopColore0edf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    d: "M479.5,349c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C484.4,356.5,484.4,351.9,479.5,349z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 458.542,
    x2: 515.192,
    y1: 377.25,
    y2: 313.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#47ccd7",
    stopOpacity: 0.603,
    className: "stopColor4792d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#4ecfd9",
    stopOpacity: 0.46,
    className: "stopColor4e96d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#59d1db",
    stopOpacity: 0.358,
    className: "stopColor599ddb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6ad6df",
    stopOpacity: 0.276,
    className: "stopColor6aa7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#80dde4",
    stopOpacity: 0.205,
    className: "stopColor80b4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#9ce4ea",
    stopOpacity: 0.142,
    className: "stopColor9cc4ea svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#bcedf1",
    stopOpacity: 0.086,
    className: "stopColorbcd7f1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#e0f6f8",
    stopOpacity: 0.036,
    className: "stopColore0edf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    d: "M514.7,328.6c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C519.6,336.1,519.6,331.4,514.7,328.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 458.542,
    x2: 515.192,
    y1: 377.25,
    y2: 313.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#47ccd7",
    stopOpacity: 0.603,
    className: "stopColor4792d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#4ecfd9",
    stopOpacity: 0.46,
    className: "stopColor4e96d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#59d1db",
    stopOpacity: 0.358,
    className: "stopColor599ddb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6ad6df",
    stopOpacity: 0.276,
    className: "stopColor6aa7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#80dde4",
    stopOpacity: 0.205,
    className: "stopColor80b4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#9ce4ea",
    stopOpacity: 0.142,
    className: "stopColor9cc4ea svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#bcedf1",
    stopOpacity: 0.086,
    className: "stopColorbcd7f1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#e0f6f8",
    stopOpacity: 0.036,
    className: "stopColore0edf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    d: "M514.8,349c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C519.7,356.5,519.7,351.9,514.8,349z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 458.542,
    x2: 515.192,
    y1: 377.25,
    y2: 313.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#47ccd7",
    stopOpacity: 0.603,
    className: "stopColor4792d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#4ecfd9",
    stopOpacity: 0.46,
    className: "stopColor4e96d9 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#59d1db",
    stopOpacity: 0.358,
    className: "stopColor599ddb svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    stopColor: "#6ad6df",
    stopOpacity: 0.276,
    className: "stopColor6aa7df svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#80dde4",
    stopOpacity: 0.205,
    className: "stopColor80b4e4 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861,
    stopColor: "#9ce4ea",
    stopOpacity: 0.142,
    className: "stopColor9cc4ea svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#bcedf1",
    stopOpacity: 0.086,
    className: "stopColorbcd7f1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#e0f6f8",
    stopOpacity: 0.036,
    className: "stopColore0edf8 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ad)",
    d: "M479.4,328.6c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c4.9,2.9,13,2.9,17.9,0C484.3,336.1,484.3,331.4,479.4,328.6z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: 469.255,
    x2: 474.741,
    y1: 349.352,
    y2: 369.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ae)",
    d: "M479.5,349c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C484.4,356.5,484.4,351.9,479.5,349z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: 504.445,
    x2: 509.932,
    y1: 328.902,
    y2: 349.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#af)",
    d: "M514.7,328.6c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C519.6,336.1,519.6,331.4,514.7,328.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 504.559,
    x2: 510.048,
    y1: 349.349,
    y2: 369.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ag)",
    d: "M514.8,349c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C519.7,356.5,519.7,351.9,514.8,349z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 469.142,
    x2: 474.628,
    y1: 328.902,
    y2: 349.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ah)",
    d: "M479.4,328.6c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c4.9,2.9,13,2.9,17.9,0C484.3,336.1,484.3,331.4,479.4,328.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 379.099,
    x2: 396.242,
    y1: 323.756,
    y2: 313.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#d6f4f6",
    stopOpacity: 0.219,
    className: "stopColord6e6f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ai)",
    d: "M390.5,317.1c-5.9-3.4-15.4-3.4-21.2,0 c-5.8,3.4-5.8,8.9,0.1,12.3c5.9,3.4,15.4,3.4,21.2,0C396.4,326,396.4,320.5,390.5,317.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: 417.401,
    x2: 430.044,
    y1: 345.189,
    y2: 335.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633,
    stopColor: "#d6f4f6",
    stopOpacity: 0.219,
    className: "stopColord6e6f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aj)",
    d: "M428.2,338.9c-5.9-3.4-15.4-3.4-21.2,0 c-5.8,3.4-5.8,8.9,0.1,12.3c5.9,3.4,15.4,3.4,21.2,0C434.1,347.7,434.1,342.2,428.2,338.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 389.846,
    x2: 373.952,
    y1: 341.435,
    y2: 324.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ak)",
    d: "M385.7,319.3c-5.9-3.4-15.4-3.4-21.2,0 c-5.8,3.4-5.8,8.9,0.1,12.3c5.9,3.4,15.4,3.4,21.2,0C391.6,328.2,391.5,322.7,385.7,319.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 427.547,
    x2: 411.654,
    y1: 363.202,
    y2: 345.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#al)",
    d: "M423.4,341c-5.9-3.4-15.4-3.4-21.2,0 c-5.8,3.4-5.8,8.9,0.1,12.3c5.9,3.4,15.4,3.4,21.2,0C429.3,349.9,429.2,344.4,423.4,341z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 394.94,
    x2: 358.183,
    y1: 313.368,
    y2: 313.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#am)",
    d: "M389.1,302.2c-7.8-4.5-20.4-4.5-28.1,0 c-7.7,4.5-7.7,17.8,0.1,22.3c7.8,4.5,20.4,4.5,28.1,0C396.9,320,396.9,306.7,389.1,302.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 431.936,
    x2: 402.87,
    y1: 335.135,
    y2: 335.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#an)",
    d: "M426.8,324c-7.8-4.5-20.4-4.5-28.1,0 c-7.7,4.5-7.7,17.8,0.1,22.3c7.8,4.5,20.4,4.5,28.1,0C434.6,341.8,434.6,328.5,426.8,324z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 373.046,
    x2: 381.663,
    y1: 302.411,
    y2: 334.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ao)",
    d: "M389.1,301.9c-7.8-4.5-20.4-4.5-28.1,0 c-7.7,4.5-7.7,11.8,0.1,16.3c7.8,4.5,20.4,4.5,28.1,0C396.9,313.7,396.9,306.4,389.1,301.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 374.143,
    x2: 377.39,
    y1: 298.639,
    y2: 335.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ap)",
    d: "M375.2,317.9c-4.7,0-9.3-1.1-12.6-3 c-2.8-1.6-4.4-3.6-4.4-5.6c0-1.9,1.6-3.9,4.3-5.5c3.2-1.9,7.8-3,12.5-3c4.7,0,9.3,1.1,12.6,3c2.8,1.6,4.4,3.6,4.4,5.6 c0,1.9-1.6,3.9-4.3,5.5C384.4,316.9,379.9,317.9,375.2,317.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 410.748,
    x2: 419.365,
    y1: 324.178,
    y2: 356.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aq)",
    d: "M426.8,323.7c-7.8-4.5-20.4-4.5-28.1,0 c-7.7,4.5-7.7,11.8,0.1,16.3c7.8,4.5,20.4,4.5,28.1,0C434.6,335.5,434.6,328.2,426.8,323.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 411.845,
    x2: 415.091,
    y1: 320.406,
    y2: 357.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ar)",
    d: "M412.9,339.7c-4.7,0-9.3-1.1-12.6-3 c-2.8-1.6-4.4-3.6-4.4-5.6c0-1.9,1.6-3.9,4.3-5.5c3.2-1.9,7.8-3,12.5-3c4.7,0,9.3,1.1,12.6,3c2.8,1.6,4.4,3.6,4.4,5.6 c0,1.9-1.6,3.9-4.3,5.5C422.1,338.6,417.6,339.7,412.9,339.7z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: 467.276,
    x2: 473.518,
    y1: 350.934,
    y2: 372.478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#as)",
    d: "M480.5,354.6v-4.2l-2.1,0.5 c-0.5-0.4-1-0.8-1.6-1.1c-5-2.9-13-2.9-17.9,0c-0.9,0.5-1.6,1.1-2.1,1.7l-1.5-1v4.6h0c0,1.9,1.3,3.7,3.7,5.2 c5,2.9,13,2.9,17.9,0C479.5,358.6,480.7,356.6,480.5,354.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 466.322,
    x2: 476.338,
    y1: 328.848,
    y2: 354.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#at)",
    d: "M479,331.1c-0.6-0.6-1.3-1.2-2.3-1.8 c-5-2.9-13-2.9-17.9,0c-0.9,0.5-1.6,1.1-2.1,1.6l-1.6-0.9v4.3l0,0c-0.1,1.9,1.2,3.9,3.7,5.3c4.9,2.9,13,2.9,17.9,0 c2.5-1.4,3.7-3.3,3.7-5.2V330L479,331.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 502.404,
    x2: 507.892,
    y1: 349.987,
    y2: 370.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#au)",
    d: "M515.8,350.4l-2.1,0.5 c-0.5-0.4-1-0.8-1.6-1.1c-5-2.9-13-2.9-17.9,0c-0.8,0.4-1.4,0.9-1.9,1.5l-1.7-0.8v4.4l0,0c-0.1,1.9,1.2,3.9,3.7,5.4 c5,2.9,13,2.9,17.9,0c2.5-1.4,3.7-3.3,3.7-5.2l0,0V350.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 502.313,
    x2: 507.799,
    y1: 329.534,
    y2: 350.083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#av)",
    d: "M490.5,334.7c0.1,1.8,1.3,3.6,3.7,5 c5,2.9,13,2.9,17.9,0c2.5-1.4,3.7-3.3,3.7-5.2v-4.7l-2.2,0.7c-0.5-0.4-1-0.8-1.6-1.1c-5-2.9-13-2.9-17.9,0 c-0.9,0.5-1.6,1-2.1,1.6l-1.6-1v4.4c0,0.1,0,0.1,0,0.2L490.5,334.7L490.5,334.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 466.594,
    x2: 472.08,
    y1: 345.565,
    y2: 366.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aw)",
    d: "M476.8,345.3c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C481.8,352.8,481.8,348.1,476.8,345.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 501.784,
    x2: 507.271,
    y1: 325.115,
    y2: 345.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ax)",
    d: "M512,324.8c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C517,332.3,516.9,327.7,512,324.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 501.899,
    x2: 507.387,
    y1: 345.562,
    y2: 366.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ay)",
    d: "M512.1,345.3c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c5,2.9,13,2.9,17.9,0C517.1,352.8,517.1,348.1,512.1,345.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 466.481,
    x2: 471.967,
    y1: 325.114,
    y2: 345.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#az)",
    d: "M476.7,324.8c-5-2.9-13-2.9-17.9,0 c-4.9,2.9-4.9,7.5,0.1,10.4c4.9,2.9,13,2.9,17.9,0C481.7,332.3,481.6,327.7,476.7,324.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aA",
    x1: 488.929,
    x2: 416.25,
    y1: 248.502,
    y2: 110.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#11c3d1",
    className: "stopColor116bd1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#55cad3",
    className: "stopColor5577d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#81cfd5",
    className: "stopColor8b81d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#88d0d6",
    className: "stopColorb288d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#8cd1d7",
    className: "stopColorca8cd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aA)",
    d: "M426.1,167.8l3.2,43.6 c0,3.3,1.1,6.5,3.2,9.1l35.4,44c1.3,1.6,3.4,2.5,5.4,2.3l28-0.1c1.3-0.1,6.3-3.2,7.2-4c1.4-1.2,2.3-2.9,2.3-4.9l0.1-44 c0-2.8-0.9-5.5-2.7-7.7l-35.9-44.6c-1.3-1.6-3.4-2.5-5.4-2.3l-31.7,2.7c-1.3,0.1-2.5,0.6-3.4,1.4 C430.3,164.5,426.1,165.8,426.1,167.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aB",
    x1: 496.394,
    x2: 445.245,
    y1: 304.659,
    y2: 157.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#11c3d1",
    className: "stopColor116bd1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#55cad3",
    className: "stopColor5577d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#81cfd5",
    className: "stopColor8b81d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#88d0d6",
    className: "stopColorb288d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#8cd1d7",
    className: "stopColorca8cd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aB)",
    d: "M424.8,170.9l-0.1,43.2 c0,3.3,1.1,6.5,3.2,9.1l35.4,44c1.3,1.6,3.4,2.5,5.4,2.3l31.7-2.7c3.2-0.3,5.7-3,5.8-6.3l0.1-44c0-2.8-0.9-5.5-2.7-7.7 l-35.9-44.6c-1.3-1.6-3.4-2.5-5.4-2.3l-31.7,2.7C427.3,165,424.8,167.7,424.8,170.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aC",
    x1: 432.768,
    x2: 458.588,
    y1: 144.714,
    y2: 97.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    stopOpacity: 0,
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#11c3d1",
    stopOpacity: 0.06,
    className: "stopColor116bd1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#55cad3",
    stopOpacity: 0.315,
    className: "stopColor5577d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#81cfd5",
    stopOpacity: 0.546,
    className: "stopColor8b81d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#88d0d6",
    stopOpacity: 0.745,
    className: "stopColorb288d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#8cd1d7",
    stopOpacity: 0.902,
    className: "stopColorca8cd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aC)",
    d: "M443,109.5c0.2-0.6,0.3-1.3,0.3-2.1 c0-4.3-3-9.5-6.7-11.6c-3.7-2.1-6.7-0.4-6.7,3.9c0,4.3,3,9.5,6.7,11.6c0.7,0.4,1.3,0.7,1.9,0.8l6.2,10.8c1.3,2.3,2.1,4.8,2.1,7 l-0.1,26.4l6.4,3.7l0.1-26.4c0-4.1-1.4-8.9-3.9-13.3L443,109.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aD",
    x1: 484.21,
    x2: 510.031,
    y1: 172.828,
    y2: 125.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    stopOpacity: 0,
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#11c3d1",
    stopOpacity: 0.06,
    className: "stopColor116bd1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#55cad3",
    stopOpacity: 0.315,
    className: "stopColor5577d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#81cfd5",
    stopOpacity: 0.546,
    className: "stopColor8b81d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#88d0d6",
    stopOpacity: 0.745,
    className: "stopColorb288d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#8cd1d7",
    stopOpacity: 0.902,
    className: "stopColorca8cd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aD)",
    d: "M501.9,133.5c-3.7-2.1-6.7-0.4-6.7,3.9 c0,0.8,0.1,1.6,0.3,2.4l-6.3,3.6c-2.6,1.5-4,4.5-4,8.7l-0.1,26.4l6.4,3.7l0.1-26.4c0-2.2,0.8-3.8,2.1-4.6l6.3-3.6 c0.6,0.6,1.3,1.1,1.9,1.4c3.7,2.1,6.7,0.4,6.7-3.8C508.6,140.9,505.6,135.7,501.9,133.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aE",
    x1: 469.242,
    x2: 469.242,
    y1: 155.62,
    y2: 96.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    stopOpacity: 0,
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.083,
    stopColor: "#11c3d1",
    stopOpacity: 0.06,
    className: "stopColor116bd1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#55cad3",
    stopOpacity: 0.315,
    className: "stopColor5577d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558,
    stopColor: "#81cfd5",
    stopOpacity: 0.546,
    className: "stopColor8b81d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#88d0d6",
    stopOpacity: 0.745,
    className: "stopColorb288d6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.905,
    stopColor: "#8cd1d7",
    stopOpacity: 0.902,
    className: "stopColorca8cd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aE)",
    d: "M469.3,97.7c-3.7-2.1-6.7-0.4-6.7,3.8 c0,2.9,1.4,6.3,3.5,8.8l-0.1,42.1l6.4,3.7l0.1-42.1c2.1-0.1,3.6-1.8,3.6-4.8C476,105.1,473,99.9,469.3,97.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aF",
    x1: 449.755,
    x2: 451.041,
    y1: 237.718,
    y2: 177.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aF)",
    d: "M454.7,209.8c0,1.3,0,3,0.2,5.2l-0.1,0 l-6.6-18.3l-6.4-3.7l-0.1,20.9l4.4,2.5l0-9.4c0-1.2-0.1-3-0.2-5.4l0.1,0.1l6.6,18.6l6.4,3.7l0.1-20.9l-4.4-2.5L454.7,209.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aG",
    x1: 467.777,
    x2: 469.063,
    y1: 238.104,
    y2: 178.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aG)",
    points: "462.9 226 467.8 228.8 467.8 221 473.3 224.1 473.3 219.6 467.8 216.4 467.8 212.5 473.7 215.9 473.7 211.3 463 205.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aH",
    x1: 481.863,
    x2: 483.148,
    y1: 238.406,
    y2: 178.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aH)",
    points: "475.4 216.9 479.8 219.5 479.8 235.8 484.7 238.6 484.7 222.3 489.2 224.9 489.2 220.2 475.4 212.3"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aI",
    x1: 299.655,
    x2: 302.753,
    y1: 227.311,
    y2: 274.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aI)",
    d: "M324.7,274v44.1c0,1.9-2,3.1-3.7,2.1 l-36.4-21.1c-1.6-0.9-2.5-2.6-2.5-4.4v-44.2c0-1.8,1.9-2.9,3.4-2l36.7,21.1C323.7,270.5,324.7,272.2,324.7,274z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aJ",
    x1: 294.787,
    x2: 322.859,
    y1: 260.11,
    y2: 365.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aJ)",
    d: "M322.8,274.7v44.1 c0,1.9-2,3.1-3.7,2.1l0,0l-36.4-21.1c-1.6-0.9-2.5-2.6-2.5-4.4v-44.2c0-1.8,1.9-2.9,3.4-2l36.7,21.1 C321.8,271.2,322.8,272.9,322.8,274.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aK",
    x1: 306.204,
    x2: 307.223,
    y1: 326.199,
    y2: 289.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aK)",
    d: "M311.2,285.5l-7.4-4.3l-0.6,7.5 l3.1,1.8c1,0.6,1.8,1.2,2.2,1.7c0.4,0.5,0.6,1.1,0.6,1.7c0,0.6-0.2,0.9-0.6,1c-0.4,0.1-1-0.1-1.7-0.5c-0.6-0.4-1.3-0.8-1.9-1.4 c-0.6-0.6-1.1-1.2-1.6-1.9l-1.1,1.8c0.6,0.8,1.3,1.6,2.1,2.3c0.8,0.7,1.7,1.4,2.5,1.8c1.1,0.6,2,1,2.8,1c0.8,0,1.3-0.2,1.7-0.7 c0.4-0.5,0.6-1.2,0.6-2c0-1.3-0.4-2.6-1.2-3.9c-0.8-1.3-2.1-2.4-3.8-3.4l-1-0.6l0.2-2.5l5.1,2.9L311.2,285.5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aL",
    x1: 241.783,
    x2: 299.11,
    y1: 247.659,
    y2: 285.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    stopColor: "#82cfd5",
    className: "stopColor9082d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aL)",
    d: "M291.9,285.1l0-2.9l2,1.1 c0.5,0.3,0.9,0.6,1.1,1.1c0.3,0.4,0.4,0.9,0.4,1.3c0,1-0.5,1.1-1.5,0.6L291.9,285.1 M291.9,280l0-2.8l1.8,1 c1,0.6,1.5,1.3,1.5,2.3c0,0.9-0.5,1.1-1.4,0.6L291.9,280 M295.3,274.8L294,274l0,1.7l-1.5-0.9l0-1.7l-1.3-0.8l0,1.7l-1.9-1.1 l0,13.1l1.9,1.1l0,1.5l1.3,0.8l0-1.5l1.5,0.9l0,1.5l1.4,0.8l0-1.6c0.8,0.4,1.5,0.4,2,0.2c0.7-0.3,1-0.9,1-2.1 c0-0.8-0.2-1.5-0.6-2.4c-0.4-0.8-0.9-1.5-1.6-2.1c0.6,0.2,1.1,0.1,1.4-0.2c0.4-0.3,0.6-0.9,0.6-1.7c0-1.1-0.3-2.1-0.9-3 c-0.5-0.7-1-1.3-1.7-1.8L295.3,274.8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aM",
    cx: 301.66,
    cy: 319.775,
    r: 6.941,
    gradientTransform: "matrix(-.5286 .8489 -3.7473 -2.3335 1659.41 809.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#45ccd7",
    stopOpacity: 0.39,
    className: "stopColor4591d7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#d6f4f6",
    stopOpacity: 0.086,
    className: "stopColord6e6f6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aM)",
    d: "M283.3,310.9l34.7,21.9 c0.8,0.5,1.8,0.5,2.7,0l0,0c1.5-1,1.5-3.2,0-4.1l-34.3-22.1c-0.8-0.5-1.9-0.5-2.7,0l-0.4,0.3C281.7,307.8,281.8,310,283.3,310.9z "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aN",
    x1: 368.749,
    x2: 413.32,
    y1: 192.279,
    y2: 239.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aN)",
    d: "M401.8,203.9v-40.1 c0-1.7-1.9-2.8-3.4-1.9l-48.1,27.9c-1.4,0.8-2.3,2.3-2.3,4V234c0,1.6,1.8,2.6,3.1,1.8l48.3-27.9 C401,207.1,401.8,205.6,401.8,203.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aO",
    x1: 393.73,
    x2: 338.444,
    y1: 229.538,
    y2: 131.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aO)",
    d: "M403.6,204.6v-40.1 c0-1.7-1.9-2.8-3.4-1.9l-48.1,27.9c-1.4,0.8-2.3,2.3-2.3,4v40.3c0,1.6,1.8,2.6,3.1,1.8l48.3-27.9 C402.7,207.7,403.6,206.2,403.6,204.6z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.29,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 371.3,
    x2: 359.5,
    y1: 215.3,
    y2: 222.2,
    fill: "none",
    stroke: "#20c9d7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.661,
    className: "colorStroke2062d7 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383,
    x2: 359.6,
    y1: 202.7,
    y2: 216.2,
    fill: "none",
    stroke: "#20c9d7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.661,
    className: "colorStroke2062d7 svgStroke"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 371.3,
    x2: 359.5,
    y1: 215.3,
    y2: 222.2,
    fill: "none",
    stroke: "#06c8d7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    className: "colorStroke0660d7 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383,
    x2: 359.6,
    y1: 202.7,
    y2: 216.2,
    fill: "none",
    stroke: "#06c8d7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    className: "colorStroke0660d7 svgStroke"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aP",
    x1: 358.6,
    x2: 364.064,
    y1: 183.32,
    y2: 202.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aP)",
    d: "M367.6,193.4l-1.7,1 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4l0,5.3l-5-2.5c-0.2-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.2,0-0.3,0.1 c-0.2,0.1-0.3,0.4-0.3,0.8l0,10.4c0,0.1,0,0.2,0.1,0.3c0.1,0,0.1,0,0.3-0.1l1.7-1c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.1-0.2,0.1-0.4l0-5.3l5,2.5c0.2,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2,0,0.3-0.1c0.2-0.1,0.3-0.4,0.3-0.8l0-10.4 C368,193.4,367.9,193.3,367.6,193.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aQ",
    x1: 368.996,
    x2: 374.461,
    y1: 180.325,
    y2: 199.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aQ)",
    d: "M376.4,188.4l-5.9,3.4 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4l0,10.4c0,0.1,0,0.2,0.1,0.3c0.1,0,0.2,0,0.3-0.1l1.7-1 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4l0-3.3c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.1,0.2-0.2l3.2-1.8 c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.1-0.2,0.1-0.4l0-1.7c0-0.1,0-0.2-0.1-0.3c-0.1,0-0.2,0-0.3,0.1l-3.2,1.8 c-0.1,0-0.1,0.1-0.2,0c0,0,0-0.1,0-0.2l0-1.6c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.1,0.2-0.2l3.7-2.1c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.1-0.2,0.1-0.4l0-1.7C376.7,188.3,376.6,188.2,376.4,188.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aR",
    x1: 378.68,
    x2: 384.144,
    y1: 177.535,
    y2: 196.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aR)",
    d: "M385.2,183.4c-0.1,0-0.1,0-0.3,0.1 l-7.2,4.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.1,0.2-0.1,0.4l0,1.7c0,0.1,0,0.2,0.1,0.3c0.1,0,0.1,0,0.3-0.1l2.2-1.3 c0.1,0,0.1-0.1,0.2,0c0,0,0.1,0.1,0.1,0.2l0,8c0,0.1,0,0.2,0.1,0.3c0.1,0,0.1,0,0.3-0.1l1.7-1c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.1-0.2,0.1-0.4l0-8c0-0.1,0-0.2,0-0.2c0-0.1,0.1-0.1,0.2-0.1l2.2-1.3c0.1-0.1,0.2-0.2,0.3-0.3 c0.1-0.1,0.1-0.2,0.1-0.4l0-1.7C385.3,183.5,385.3,183.4,385.2,183.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aS",
    x1: 397.149,
    x2: 403.987,
    y1: 187.746,
    y2: 219.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#53cad3",
    className: "stopColor5377d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#83cfd5",
    className: "stopColor9883d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#8bd1d7",
    className: "stopColorc38bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aS)",
    d: "M410.4,211.5v-12.8 c0-0.6-0.6-0.9-1.1-0.6L394,207c-0.5,0.3-0.7,0.7-0.7,1.3v12.9c0,0.5,0.6,0.8,1,0.6l15.4-8.9C410.2,212.5,410.4,212,410.4,211.5z "
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aT",
    x1: 430.112,
    x2: 379.487,
    y1: 427.986,
    y2: 385.557,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#53cad3",
    className: "stopColor5377d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#83cfd5",
    className: "stopColor9883d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#8bd1d7",
    className: "stopColorc38bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aT)",
    d: "M333.2,426.5l8.9-36 c0.3-1-0.2-2.1-1.1-2.6l-46.8-27c-1-0.6-2.4,0-2.7,1.1l-9.1,36.7c-0.3,1,0.2,2.1,1.1,2.6l46.1,26.6 C331.1,428.7,332.8,428,333.2,426.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aU",
    x1: 375.728,
    x2: 357.889,
    y1: 447.728,
    y2: 415.745,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aU)",
    d: "M279.8,401.8L243.1,423 c-1,0.6-1,2,0,2.6l45.9,26.5c1.4,0.8,3.1,0.8,4.5,0l35.8-20.7c1-0.6,1-2,0-2.6l-46.8-27C281.8,401.3,280.7,401.3,279.8,401.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aV",
    x1: 415.97,
    x2: 378.982,
    y1: 470.158,
    y2: 363.723,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#53cad3",
    className: "stopColor5377d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#83cfd5",
    className: "stopColor9883d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#8bd1d7",
    className: "stopColorc38bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aV)",
    d: "M332.4,425.8l8.9-36 c0.3-1-0.2-2.1-1.1-2.6l-46.8-27c-1-0.6-2.4,0-2.7,1.1l-9.1,36.7c-0.3,1,0.2,2.1,1.1,2.6l46.1,26.6 C330.2,428,332,427.3,332.4,425.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aW",
    x1: -1583.434,
    x2: -1557.72,
    y1: 372.707,
    y2: 416.85,
    gradientTransform: "matrix(-1 0 0 1 -1259.711 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aW)",
    d: "M330.1,425.6c-0.1,0-0.1,0-0.2,0 l-46.1-26.6c-0.1-0.1-0.2-0.2-0.2-0.4l9-36.5l46.5,26.9c0.1,0.1,0.2,0.2,0.2,0.4l-8.9,36C330.4,425.5,330.2,425.6,330.1,425.6 L330.1,425.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aX",
    x1: -1557.91,
    x2: -1539.91,
    y1: 398.39,
    y2: 439.854,
    gradientTransform: "matrix(-1 0 0 1 -1259.711 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#53cad3",
    className: "stopColor5377d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#83cfd5",
    className: "stopColor9883d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#8bd1d7",
    className: "stopColorc38bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aX)",
    d: "M279.8,400.5l-36.7,21.2 c-1,0.6-1,2,0,2.6l45.9,26.5c1.4,0.8,3.1,0.8,4.5,0l35.8-20.7c1-0.6,1-2,0-2.6l-46.8-27C281.8,400,280.7,400,279.8,400.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aY",
    x1: -1577.049,
    x2: -1563.334,
    y1: 383.952,
    y2: 417.809,
    gradientTransform: "matrix(-1 0 0 1 -1259.711 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#88dce3",
    className: "stopColore388d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    stopOpacity: 0,
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aY)",
    points: "328.5 408.3 325.4 400.2 318.7 404.2 320.1 386.2 312.3 395.8 309.5 390.8 303.7 395.8 299.7 381.9 297.4 378.1 292.5 397 326.4 416.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aZ",
    x1: -1579.124,
    x2: -1568.196,
    y1: 382.033,
    y2: 407.533,
    gradientTransform: "matrix(-1 0 0 1 -1259.711 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    stopOpacity: 0,
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#aZ)",
    points: "326.4 416.6 327.6 411.9 325.7 407.2 315.1 406.2 312.3 398 305.8 401.4 305.2 388.2 297.8 394.5 294.6 389.2 292.5 397"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 364.739,
    x2: 361.471,
    y1: 415.296,
    y2: 410.981,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#ba)",
    points: "290.4 413.6 285.4 410.8 280.5 413.6 285.5 416.5 290.4 413.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 371.764,
    x2: 368.495,
    y1: 419.352,
    y2: 415.036,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bb)",
    points: "297.4 417.7 292.5 414.8 287.5 417.7 292.5 420.6 297.4 417.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 378.789,
    x2: 375.52,
    y1: 423.408,
    y2: 419.092,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bc)",
    points: "304.5 421.8 299.5 418.9 294.6 421.8 299.5 424.6 304.5 421.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 385.811,
    x2: 382.543,
    y1: 427.462,
    y2: 423.147,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bd)",
    points: "311.5 425.8 306.5 422.9 301.6 425.8 306.5 428.7 311.5 425.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 357.875,
    x2: 354.606,
    y1: 419.285,
    y2: 414.97,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#be)",
    points: "283.6 417.6 278.6 414.8 273.6 417.6 278.6 420.5 283.6 417.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 360.305,
    x2: 374.825,
    y1: 420.481,
    y2: 425.711,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bf)",
    points: "290.6 421.7 285.6 418.8 280.7 421.7 285.6 424.6 290.6 421.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 371.925,
    x2: 368.656,
    y1: 427.397,
    y2: 423.081,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bg)",
    points: "297.6 425.7 292.6 422.9 287.7 425.7 292.7 428.6 297.6 425.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 378.947,
    x2: 375.679,
    y1: 431.451,
    y2: 427.136,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bh)",
    points: "304.6 429.8 299.7 426.9 294.7 429.8 299.7 432.7 304.6 429.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 346.416,
    x2: 360.936,
    y1: 420.414,
    y2: 425.644,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bi)",
    points: "276.7 421.6 271.7 418.7 266.8 421.6 271.7 424.5 276.7 421.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 358.036,
    x2: 354.767,
    y1: 427.33,
    y2: 423.014,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bj)",
    points: "283.7 425.7 278.7 422.8 273.8 425.7 278.8 428.5 283.7 425.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 365.061,
    x2: 361.792,
    y1: 431.386,
    y2: 427.07,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bk)",
    points: "290.7 429.7 285.8 426.9 280.8 429.7 285.8 432.6 290.7 429.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: 367.488,
    x2: 382.009,
    y1: 432.58,
    y2: 437.81,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#ffffff",
    className: "stopColorffffff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83eef6",
    className: "stopColor83b8f6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bl)",
    points: "297.8 433.8 292.8 430.9 287.8 433.8 292.8 436.7 297.8 433.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: 344.147,
    x2: 340.878,
    y1: 427.263,
    y2: 422.948,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bm)",
    points: "269.8 425.6 264.9 422.7 259.9 425.6 264.9 428.5 269.8 425.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 351.172,
    x2: 347.903,
    y1: 431.319,
    y2: 427.003,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bn)",
    points: "276.9 429.7 271.9 426.8 266.9 429.7 271.9 432.5 276.9 429.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 358.197,
    x2: 354.928,
    y1: 435.375,
    y2: 431.059,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bo)",
    points: "283.9 433.7 278.9 430.8 274 433.7 278.9 436.6 283.9 433.7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x1: 365.219,
    x2: 361.95,
    y1: 439.429,
    y2: 435.114,
    gradientTransform: "translate(-78.022)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ccedd",
    className: "stopColor0c6add svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#00b7c6",
    className: "stopColor0043c6 svgShape"
  })), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#bp)",
    points: "290.9 437.8 285.9 434.9 281 437.8 286 440.6 290.9 437.8"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 348.239,
    x2: 303.239,
    y1: 210.502,
    y2: 150.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#53cad3",
    className: "stopColor5377d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#83cfd5",
    className: "stopColor9883d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#8bd1d7",
    className: "stopColorc38bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#bq)",
    d: "M291.3,168.3v44.1c0,1.9,2,3.1,3.7,2.1 l52.8-30.6c1.6-0.9,2.5-2.6,2.5-4.4v-44.2c0-1.8-1.9-2.9-3.4-2L293.8,164C292.2,164.8,291.3,166.5,291.3,168.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 322.73,
    x2: 322.73,
    y1: 146.786,
    y2: 205.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.025,
    stopColor: "#00c2d1",
    className: "stopColor0068d1 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#53cad3",
    className: "stopColor5377d3 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#83cfd5",
    className: "stopColor9883d5 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#8bd1d7",
    className: "stopColorc38bd7 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8ed2d7",
    className: "stopColord38ed7 svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#br)",
    d: "M293.2,169v44.1c0,1.9,2,3.1,3.7,2.1 l52.8-30.6c1.6-0.9,2.5-2.6,2.5-4.4V136c0-1.8-1.9-2.9-3.4-2l-53.1,30.6C294.2,165.5,293.2,167.2,293.2,169z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 337.3,
    x2: 337.3,
    y1: 184.1,
    y2: 154.9,
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    className: "colorStrokeffffff svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.6,
    x2: 324.6,
    y1: 191.4,
    y2: 161.2,
    fill: "none",
    stroke: "#8fd4da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    className: "colorStrokeda8fda svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.1,
    x2: 313.1,
    y1: 198,
    y2: 178,
    fill: "none",
    stroke: "#a5e6eb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    className: "colorStrokea5caeb svgStroke"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#2564d7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.4,
    points: "342.4 181.2 303 203.9 303 175.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a5e6eb",
    points: "311.2 194.6 315 192.4 315 181.4 311.2 183.6",
    className: "colora5caeb svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#8fd4da",
    points: "322.7 181.4 326.5 179.2 326.5 167.6 322.7 169.8",
    className: "colorda8fda svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "335.4 176.2 339.2 174 339.1 167.6 335.4 169.8",
    className: "colorffffff svgShape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftGame);
export default __webpack_public_path__ + "static/media/nft-game.e8e9b12d8ec6761ffdbad67ac7416d34.svg";
export { ForwardRef as ReactComponent };